import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const DAYJS_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable()
export class DayjsDateAdapter extends NativeDateAdapter {
  parse(value: string | number | Dayjs | Date): Date | null {
    if (value && typeof value === 'string') {
      const parsed = dayjs.utc(value, 'MM/DD/YYYY', true);
      return parsed.isValid() ? parsed.toDate() : null;
    }
    return value ? dayjs.utc(value).toDate() : null;
  }

  format(date: Date, displayFormat: string): string {
    if (!date) return '';
    const dayjsDate = dayjs.utc(date);
    return dayjsDate.format(displayFormat);
  }

  today(): Date {
    return dayjs.utc().toDate();
  }

  override getDate(date: Date): number {
    return dayjs.utc(date).date();
  }

  override getMonth(date: Date): number {
    return dayjs.utc(date).month();
  }

  override getYear(date: Date): number {
    return dayjs.utc(date).year();
  }

  override createDate(year: number, month: number, date: number): Date {
    return dayjs.utc().year(year).month(month).date(date).toDate();
  }
}
